<template>
    <md-app>
        <md-app-content>
            <div class="md-layout" :style="`${showLangPicker ? 'flex-direction: row-reverse;' : ''} justify-content: space-between;`" v-if="showLangPicker || backToOrigin">
                <SelectField v-if="showLangPicker"
                  v-model="$i18n.locale"
                  :options="langs"
                  @input="handleLocale"
                  class="md-layout-item md-small-size-100 md-size-20"
                ></SelectField>

                <md-button v-if="backToOrigin && backToOrigin.url"
                    class="md-primary"
                    :href="backToOrigin.url"
                  >
                  <i class="fas fa-chevron-left"></i>
                  <span style="margin-left: 15px" v-if="backToOrigin.label">{{ $t(backToOrigin.label) }}</span>
                </md-button>
            </div>
            <div style="text-align: center" v-if="logo">
                <img :src="logo" style="max-width: 50vw; max-height: 10vh"/>
            </div>
            <md-steppers  md-alternative :md-active-step.sync="active" md-linear md-dynamic-height>
                <md-step
                        v-for="(step, index) in steps"
                        :key="index"
                        :id="step.id"
                        :md-label="$t(step.label)"
                        :md-done="state[index]"
                        :md-editable="!sending && !sent"
                >
                    <Step
                            :step="step"
                            :form="form"
                            v-model="state[index]"
                            :ref="`step_${index}`"
                    ></Step>
                    <div style="text-align: center">
                        <md-button
                                class="md-raised md-primary"
                                @click="validate(step.id, index)">
                            {{$t(isLast(step.id) ? submit.label : 'Actions.next')}}
                            &nbsp;
                            <i :class="`fas fa-${isLast(step.id)?'flag-checkered':'chevron-right'}`"></i>
                        </md-button>
                    </div>
                </md-step>
                <md-step id="sent" :md-label="$t(submit.tabTitle || 'Finish')" md-icon="fas fa-complete" :md-editable="false" :md-done="sent">
                    <div style="text-align: center">
                        <md-progress-spinner v-if="sending" class="md-accent" md-mode="indeterminate"></md-progress-spinner>
                        <h1 v-if="sent">{{$t(submit.title || 'Actions.Congratulations')}}</h1>
                        <div v-if="sent && submit.description" v-html="$t(submit.description)"></div>
                        <div v-if="error" v-html="$t(submit.errors[error] || error)"></div>
                    </div>
                </md-step>
            </md-steppers>
        </md-app-content>
    </md-app>
</template>

<script>
  import Step from './components/Step';
  import SelectField from './components/SelectField';

  export default {
    name: 'App',
    components: {
      Step,
      SelectField,
    },
    data() {
      return {
        active: null,
        sending: false,
        sent: false,
        form: {... (this.$root.config.initial || {})},
        state: this.$root.config.tabs.map(() => false),
        error: null,
      }
    },
    computed: {
      logo () { return this.$root.config.logo },
      langs () { return this.$root.config.languages },
      showLangPicker () { return this.langs && this.langs.length > 1 },
      backToOrigin () { return this.$root.config.backToOriginButton },
      steps () { return this.$root.config.tabs },
      submit() { return this.$root.config.submit },
      done() { return this.state.every(x => x) },
      formdata() {
        const data = new FormData();
        Object.entries(this.form).forEach(([key, value]) => data.append(key, value));
        this.getFiles().forEach((file, idx) => data.append(`__file_${idx}`, file, file.name));
        return data;
      },
    },
    methods: {
      handleLocale(locale) {
        this.$i18n.locale = locale;
        this.$forceUpdate();
      },
      isLast(id) {
        const current = this.steps.findIndex(({id: _}) => _ === id);
        return !(current + 1 < this.steps.length);
      },
      async validate(id, index) {
        if (this.state[id] == null) {
          this.state[id] = true;
          this.$refs[`step_${index}`].forEach(x => x.validate());

          setTimeout(() => this.validate(id, index), 500);
          return;
        }

        const isStepReady = (this.isLast(id) ? this.done : this.state[index]);
        if (!isStepReady) {
          this.state[id] = null
          return;
        }

        const current = this.steps.findIndex(({id: _}) => _ === id);

        if (this.steps[current].request) {
          const {url:originalUrl, mode, method, headers, params = {}, match, success, failure} = this.steps[current].request;

          if (match(this.form)) {
            this.sending = true;
            const url = originalUrl.replace(/\$\{([0-9a-z_-]+)\}/gi, (match, group) => {
              return encodeURIComponent(this.form[group] ?? group);
            });

            const form = mode === 'json' ? this.form : this.formdata;

            try {
              const result = await this.$http?.[method.toLowerCase()](url
                  + (url.indexOf('?') >= 0 ? '&' : '?') + 'language=' + this.$root.$i18n.locale,
                  form, {headers, params});
              if (success?.(await result.json(), this.form, this.$root) === false) {
                return;
              }
            } catch (e) {
              if (failure?.(e, this.form, this.$root) !== true) {
                return;
              }
            } finally {
              this.sending = false;
              this.$forceUpdate();
            }
          }
        }

        this.active = (this.steps[current + 1] || {}).id || this.active;

        if (this.isLast(id)) {
          this.finish();
        }
      },
      async finish() {
        this.active = 'sent';
        this.sending = true;
        this.error = null;

        try {
          await this.$root.events?.onSubmit?.(this.form, this.formdata, this.$root.$i18n.locale);
        } catch(e) {
          console.error(e);
          // if (typeof this.$root.events?.onError === 'function') {
          //   this.$root.events?.onError(e, this.form, this.formdata, this.$root.$i18n.locale);
          // }
          this.error = e.message;
          this.sending = false;
          this.sent = false;
        }


        if (this.submit.request && this.$http) {
          const files = this.getFiles();

          const {url, method = 'post', headers, params = {}, mode} = this.submit.request;

          if (files.length > 0 && mode === 'json') {
            console.warn('using multipart/form-data');
          }

          const form = mode === 'json' && files.length < 1 ? this.form : this.formdata;

          try {
            await this.$http?.[method.toLowerCase()](url
                + (url.indexOf('?') >= 0 ? '&' : '?') + 'language=' + this.$root.$i18n.locale,
                form, {headers, params});

            this.$root.events?.onSuccess?.();
          } catch (e) {
            if (typeof this.$root.events?.onError === 'function') {
              this.$root.events?.onError(e);
            } else {
              throw e;
            }
          }
        }
        this.sending = false;
        this.sent = true;
      },

      getFiles() {
        return [].concat(...([].concat(...Object.values(this.$refs))).map(x => x?.getFiles?.() ?? []))
      }
    }
  }
</script>
<style>
    h1 {
        color: red
    }
    .lang-picker {
        text-align: right;

    }
</style>
